import { Layout } from "Components/Layout/Layout";
import { LoadsList } from 'Containers/Loads/LoadsList/LoadsList';

export const LoadsListPage = () => {
  return (
    <Layout>
      <LoadsList />
    </Layout>
  );
};
